export const REPORT_CONFIG = {
  // payment_audit: {
  //   label: "Payment",
  //   path: "CreditCardAudit",
  // },
  delete_audit : {
    label: "Deleted Applications",
    path: "DeleteAudit",
  }
};

export const SEARCH_BY = [
  { label: "First Name", value: "firstName" },
  { label: "Last Name", value: "lastName" },
];
